// Create our number formatter.
const formatter = new Intl.NumberFormat('it', {
  style: 'currency',
  currency: 'EUR',
  minimumFractionDigits: 0,
  // These options are needed to round to whole numbers if that's what you want.
  //minimumFractionDigits: 0, // (this suffices for whole numbers, but will print 2500.10 as $2,500.1)
  //maximumFractionDigits: 0, // (causes 2500.99 to be printed as $2,501)
});

export default (x: number) => {
  return formatter.format(x);
};

/*export function formatNumberWithThousandsSeparator(n: string) {
  return n.replace(/\D/g, '').replace(/\B(?=(\d{3})+(?!\d))/g, '.');
}*/

export function formatNumberWithThousandsSeparator(n: string) {
  // Rimuovi simboli di valuta e spazi
  n = n.replace(/[^\d.,]/g, '').trim();

  // Controlla se ci sono parti decimali
  // eslint-disable-next-line prefer-const
  let [integerPart, decimalPart] = n.split(',');

  // Rimuovi qualsiasi punto dalla parte intera
  integerPart = integerPart.replace(/\./g, '');

  // Aggiungi separatori delle migliaia alla parte intera
  integerPart = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, '.');

  // Riassembla il numero con la parte decimale se esiste
  return decimalPart ? `${integerPart},${decimalPart}` : integerPart;
}

/*export function formatNumberWithThousandsSeparator(amount: number) {
  return new Intl.NumberFormat('it-IT').format(amount);
}*/

export function removeThousandSeparator(value: string) {
  // Rimuovi i punti dalla stringa e sostituisci le virgole con punti
  return value.replace(/\./g, '').replace(/,/g, '.');
}
